import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CONTROL_OPERATIVO_CHV, CONTROL_OPERATIVO_MENSUAL_FIVI, CONTROL_OPERATIVO_TRIMESTRAL_FIVI, HOST } from 'src/app/global';
import { RespuestaControlOperativo } from 'src/app/modelos/operativo/RespuestaControlOperativo';

@Injectable({
  providedIn: 'root'
})
export class ControloperativoService {

  url: string= HOST;

constructor(
  private http: HttpClient
) { }
//informacion control operativo chv
controlOperativoChv(idPeriodo):Observable<RespuestaControlOperativo>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CONTROL_OPERATIVO_CHV + idPeriodo;
  return this.http.get<RespuestaControlOperativo>(direccion, {'headers': header});
}
//informacion control operativo fivi mmensual
controlOperativoFiviMensual(idPeriodo):Observable<RespuestaControlOperativo>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CONTROL_OPERATIVO_MENSUAL_FIVI + idPeriodo;
  return this.http.get<RespuestaControlOperativo>(direccion, {'headers': header});
}
//informacion control operativo fivi trimestral
controlOperativoFiviTrimestral(periodo, anio):Observable<RespuestaControlOperativo>{
  let header = new HttpHeaders();
  let token = "Bearer " + localStorage.getItem('token');
  header = header.set('Content-Type','application/json').set('Authorization',token);
  let direccion = this.url + CONTROL_OPERATIVO_TRIMESTRAL_FIVI + periodo + "/" + anio;
  return this.http.get<RespuestaControlOperativo>(direccion, {'headers': header});
}

}
